<template>
    <div :class="[(!taxa || taxa == 'erro') && !this.retirarNoLocal ? 'card-outline-error' : '', this.selecionado ? 'card-retirar-entrega-selecionado' : 'card-retirar-entrega']">
        <div style="display: flex;justify-content: space-between; ">

            
            <div v-if="!retirarNoLocal" style="align-items: center;display: flex;justify-content: center;">
                <img v-if="this.selecionado" class="ic-checked" src="../../assets/icons/ic_radio_checked.png" alt=""/>
                <img v-else class="ic-unchecked" src="../../assets/icons/ic_radio_unchecked.png" alt="" @click="$emit('onClickSelecionar')"/>
            </div>
            
            <div v-if="!retirarNoLocal" class="btn-editar" @click="onClickEditar">
                <img src="../../assets/icons/editar.png" alt="" />
                <p>editar</p>
            </div>

            
            <div style="width: 100%;padding: 3px;" @click="$emit('onClickSelecionar')">
                

                <div style="display: flex; align-items: center;">
                    <!-- <p>{{ JSON.stringify(this.endereco) }}</p> -->
                    <!-- <p>{{ JSON.stringify(this.taxa) }}</p> -->
                    <button v-if="retirarNoLocal" class="botao-maps" @click="abrirNoMaps">
                        <img src="../../assets/icons/maps.png" alt="">
                    </button>

                    <!-- endereco -->
                    <div style="font-size: 13px; flex: 1; text-align: start;">
                        <p>{{ this.endereco.rua }}, {{ this.endereco.numero }}</p>
                        <p>{{ this.endereco.bairro }}</p>
                        <p>{{ this.endereco.cidade }}, {{ this.endereco.uf }}</p>


                        <!-- exibir apenas caso entreguem neste bairro --> 
                        <div v-if="taxa && taxa !== 'erro'" style="font-size: 12px; margin-top: 5px;">
                            <p v-if="!retirarNoLocal">Taxa de entrega: <b>{{ trocarPorVirgula(taxa.TaxaEntrega) }}</b></p>
                            <p v-if="tempoEstimadoEntrega" style="margin-top: 0px;">Tempo estimado: <b>{{ tempoEstimadoEntrega  }} min</b></p>
                        </div>
                    </div>
                </div>

                <!-- exibir caso nao entreguem neste bairro -->
                <div v-if="(!taxa || taxa == 'erro') && !retirarNoLocal">
                    <p style="background: red; color: white; padding: 15px; margin: -15px; margin-bottom: 5px; margin-top: 1px;">Sem entrega para este bairro</p>
                </div> 

                
            </div>
            <div v-if="!retirarNoLocal" class="btn-deletar" @click="onClickDeletar">
                <img src="../../assets/icons/ic-trash.png" alt="">
                <p>Deletar</p>
            </div>
        </div>

    </div>
    
</template>

<script>
import { converterParaDinheiroString } from '@/utils/Dinheiro'
import { setarCores } from '@/utils/SetarCores';
// import ApiDelivery from '@/api/ApisDelivery'
import EnderecoModel from '@/model/enderecoModel'
export default {
    name: "CardEndereco",
    props: {
        taxa: Object,
        endereco: EnderecoModel,
        retirarNoLocal: Boolean,
        tempoEstimadoEntrega: Number,
        selecionado: Boolean,
    },
    created() {
        setarCores(this.$store.state.cor1, this.$store.state.cor2,this.$store.state.corTexto)
    },
    methods: {
        trocarPorVirgula(dindin) {
            return converterParaDinheiroString(dindin)
        },

        onClickEditar() {
            this.$emit("onClickEditar")
        },
        abrirNoMaps() {
            const query = encodeURIComponent(this.endereco.rua+' '+this.endereco.numero+' '+this.endereco.bairro+' '+this.endereco.cidade);
            console.log(query)
            const url = `https://www.google.com/maps/search/?api=1&query=${query}`;
            window.open(url, '_blank');
        },
        onClickDeletar() {
            this.$emit("onClickDeletar")
        }
    }
}
</script>

<style scoped>

.btn-editar, .btn-deletar {
    /* padding: var(--padding-padrao); */
    /* height: 50%; */
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.btn-editar{
    background:var(--gradiente-escuro);
    border-top-left-radius: var(--border-radius-padrao);
    border-bottom-left-radius: var(--border-radius-padrao);
}
.btn-deletar{
    background: var(--cor-vermelho);
    border-top-right-radius: var(--border-radius-padrao);
    border-bottom-right-radius: var(--border-radius-padrao);
}

.btn-deletar img { height: 20px; max-width: 20px; filter: invert(100%);}
.btn-editar img { height: 20px; max-width: 20px; filter: var(--inverte-se-texto-escuro);}
.btn-deletar p {font-size: 11px; color: white;margin: 0px;padding-inline: 3px;}
.btn-editar p {font-size: 11px; color: var(--cor-texto);margin: 0px;padding-inline: 3px;}
.botao-maps{
    margin-right: var(--padding-padrao);
    padding: var(--padding-padrao);
    min-height: 30px;
    border-radius: var(--border-radius-padrao);
    font-size: 0.9em;
    background: var(--cinza-claro);
    border: 1px solid var(--cinza-escuro);
}
.botao-maps img{ height: 30px;}

@keyframes card-retirar-entrega-anim {
    from { transform: translateY(-20%); opacity: 0; }
      to { transform: translateY(0%); opacity: 1; }
}
.card-retirar-entrega,.card-retirar-entrega-selecionado {
    position: relative;
    border: solid 1px var(--cinza-claro);
    border-radius: var(--border-radius-padrao);
    margin-top: var(--padding-padrao);
    padding: 3px;
    animation: card-retirar-entrega-anim 0.8s forwards;
}
.card-retirar-entrega>div>.btn-editar, .card-retirar-entrega>div>.btn-deletar, .card-retirar-entrega>div>div{
    opacity: 0.5;
}
.card-retirar-entrega-selecionado{
    border: solid 1px var(--cinza-escuro);
    background: linear-gradient(90deg, white 0%, var(--cinza-claro) 100%);
}

.ic-checked, .ic-unchecked{
    width: 20px;
    height: 20px;
}
</style>